import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

/**
 * Card de seção: título de 16px + descrição de 12px à esquerda, controles à
 * direita. `semPadding` deixa o conteúdo encostar nas bordas (tabelas).
 */
export const SecaoCard = ({
  titulo,
  descricao,
  acoes,
  children,
  rodape,
  semPadding = false,
  className,
}: {
  titulo?: ReactNode;
  descricao?: ReactNode;
  acoes?: ReactNode;
  children: ReactNode;
  rodape?: ReactNode;
  semPadding?: boolean;
  className?: string;
}) => (
  <section className={cn("flex min-w-0 flex-col overflow-hidden rounded-xl border bg-card", className)}>
    {(titulo || acoes) && (
      <div className="flex flex-wrap items-end justify-between gap-3 px-5 pb-3.5 pt-5 sm:px-6">
        <div className="flex min-w-0 flex-col gap-1">
          {titulo && <h3 className="text-base font-semibold">{titulo}</h3>}
          {descricao && <p className="text-xs text-muted-foreground">{descricao}</p>}
        </div>
        {acoes && <div className="flex flex-wrap items-center gap-2">{acoes}</div>}
      </div>
    )}
    <div className={cn(!semPadding && "px-5 pb-5 sm:px-6 sm:pb-6", semPadding && titulo && "border-t")}>{children}</div>
    {rodape && <div className="border-t px-5 py-3 sm:px-6">{rodape}</div>}
  </section>
);
